import React from "react";
import Card from "../ui/Card";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";

const AssetDetails = ({ details, loading, error }) => {
  if (loading) return <Loader />;

  if (error) {
    return (
      <div
        className="bg-white text-center"
        style={{
          border: "1px solid #E8ECF4",
          padding: "50px 20px",
        }}
      >
        <b>No Record Found</b>
      </div>
    );
  }

  if (!details) return null;

  const Item = ({ label, value }) => (
    <div className="col-lg-4 col-sm-6 mb-2">
      <div
        style={{
          fontSize: "clamp(11px, 1.0vw, 13px)",
          color: "#5A6A7E",
        }}
      >
        {label}
      </div>
      <div
        className="pt-1"
        style={{
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          fontSize: "clamp(12px, 1.0vw, 14px)",
        }}
      >
        <b>{value || "-"}</b>
      </div>
    </div>
  );

  return (
    <div
      className="bg-white"
      style={{
        border: "1px solid #E9EEF5",
        padding: "clamp(16px, 2vw, 22px)",
        boxShadow: "0 4px 18px rgba(0,0,0,.04)",
      }}
    >
      <h6
        style={{
          fontWeight: 700,
          marginBottom: "clamp(16px, 2vw, 20px)",
          color: "#3cb5a0",
          fontSize: "clamp(15px, 1.6vw, 18px)",
        }}
      >
        Asset Overview
      </h6>

      <div className="row g-4 align-items-start">
        <div className="col-xl-3 col-lg-4 col-md-12 text-center text-lg-start">
          <img
            src={details?.image}
            alt="Asset"
            style={{
              maxWidth: "100%",
              maxHeight: "clamp(120px, 15vw, 150px)",
              objectFit: "cover",
              width: "auto",
            }}
          />
        </div>

        <div className="col-xl-9 col-lg-8 col-md-12">
          <div className="row">
            <Item label="Asset Name" value={details.name} />
            <Item label="Asset Type" value={details.asset_type_name} />
            <Item label="Asset Code" value={details.asset_code} />
            <Item label="Model" value={details.model_name} />
            <Item label="Manufacturer" value={details.manufacturer_name} />
            <Item label="Site" value={details.site} />

            <div className="col-lg-4 col-md-6 mb-2">
              <div
                style={{
                  fontSize: "clamp(12px, 1.0vw, 13px)",
                  color: "#5A6A7E",
                }}
              >
                Rental Status
              </div>
              <div className="pt-1">
                {details?.rental_status ? <Status color={details?.rental_status?.color}>
                  <b
                    style={{
                      fontSize: "clamp(12px, 1.0vw, 14px)",
                    }}
                  >
                    {details?.rental_status?.name || "-"}
                  </b>
                </Status> : "-"}

              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-2">
              <div
                style={{
                  fontSize: "clamp(11px, 1.0vw, 13px)",
                  color: "#5A6A7E",
                }}
              >
                Status
              </div>
              <div className="pt-1">
                {details?.status_data ?
                  <Status color={details?.status_data?.color_code}>
                    <b
                      style={{
                        fontSize: "clamp(12px, 1.0vw, 14px)",
                      }}
                    >
                      {details?.status_data?.name || "-"}
                    </b>
                  </Status>
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetDetails;